import LeaveTypeCreateComponent from "../components/LeaveTypeCreate";
import useLeaveTypeCreate from "../hooks/useLeaveTypeCreate";

function LeaveTypeCreate() {
  const useLeaveTypeCreateProps = useLeaveTypeCreate();
  return <LeaveTypeCreateComponent {...useLeaveTypeCreateProps} />;
}

export default LeaveTypeCreate;
